export const errorHandler = (formInstance, errors) => {
  formInstance.showOverlay = false
  formInstance.isSubmitting = false
  formInstance.hasError = false
  formInstance.isBusy = false

  if (!errors.length) {
    formInstance.hasError = true
    formInstance.errorMessage = formInstance.$t('formError.unknownwError')
    return
  }

  errors.forEach(error => {
    /*
      Fehlerbehandlung für Errors, die keine errorExtension auf dem
      Server zurückgeben -> Unbekannte Fehler
    */
    if (!error.field) {
      formInstance.hasError = true
      formInstance.errorMessage = formInstance.$t('formError.unknownwError')
    }
    /*
      Fehlerbehandlung für Errors, die auf ein spezifisches Formfeld gemappt werden
    */
    const { field, i18nKey } = error

    formInstance.$refs.observer.setErrors({
      [field]: [formInstance.$t(`formError.${i18nKey}`)]
    })
  })
}

export const validateField = (valid, errors, changed) => {
  if (!changed && !errors[0]) {
    return null
  }

  return errors[0] ? false : null
}
